import domains from "./white-label"
import { config } from "@cems-eco/core/src/utils/white-label";

export default {
    production: false,
    nexus: <string>process.env.VUE_APP_NEXUS,
    BASE_URL: process.env.VUE_APP_API_BASE_ENDPOINT ?? `${window.location.protocol}//${window.location.hostname}:8082`,
    API_URL: process.env.VUE_APP_API_ENDPOINT ?? `${window.location.protocol}//${window.location.hostname}:8082/api`,
    PROXY_API_URL: process.env.VUE_APP_PROXY_API_ENDPOINT ?? '',
    rtc: {
      host: <string>process.env.VUE_APP_API_RTC_ENDPOINT ?? `ws://${window.location.hostname}:3002/stream/socket.io`,
      skip: process.env.VUE_SKIP_STREAM ?? false,
    },
    white_label: config(domains),
    mappings: {} as any,
};
